import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { CustomerBillingCustomerModel } from '@fi-app/customer-billing/customer-billing-customer/customer-billing-customer.model';
import { BillingContactModel } from '@fi-app/billing/billing-contact.model';

@Component({
    selector: 'fi-customer-billing-customer-edit-invoice-information',
    templateUrl: './customer-billing-customer-edit-invoice-information.component.html',
    styleUrls: ['./customer-billing-customer-edit-invoice-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-customer-edit-invoice-information' },
    standalone: false,
})
export class CustomerBillingCustomerEditInvoiceInformationComponent {
    @Input() customer: CustomerBillingCustomerModel;
    @Input() billingReference: BillingContactModel;
}
